/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react"
import styled from "styled-components"
import { ShareLinks } from "../common/ShareLinks"
import ApplyButton from "./ApplyButton"

const JobHeader = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 99;
  flex-direction: column;
  margin-top: 3rem;
  margin-bottom: 2rem;

  @media (min-width: 64em) {
    flex-direction: row;
    margin-top: 0;
    margin-bottom: 4rem;
  }
`
const JobInfo = styled.div``

const JobTitle = styled.h2`
  color: var(--clr-text-blue);
  font-family: var(--ff-secondary);
  font-weight: 800;
  font-size: 2.125em;
  line-height: 48px;
  letter-spacing: 0.0025em;

  @media (max-width: 40em) {
    font-size: 1.5em;
    line-height: 39px;
    letter-spacing: 0;
  }
`

const JobLocation = styled.p`
  text-align: left;
  font-size: 0.75em;
  font-weight: 700;
  margin-top: 1.8125rem;
  font-family: var(--ff-primary);

  line-height: 18px;
  letter-spacing: 0.0015em;

  @media (max-width: 64em) {
    font-family: var(--ff-secondary);
    margin-top: 0.75rem;
    margin-bottom: 2rem;
    font-weight: 600;
    font-size: 0.875em;
    line-height: 23px;
    letter-spacing: 0.05em;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 64em) {
    align-items: flex-start;
  }
`

const ShareSection = styled.div`
  display: none;
  width: fit-content;
  gap: 0.5rem;
  margin-top: 1.5rem;
  justify-content: space-between;

  a {
    border-radius: 10px;
    width: 33.81px;
    height: 32px;
  }

  @media (min-width: 64em) {
    display: flex;
  }
`

const ShareText = styled.p`
  font-family: var(--ff-primary);
  font-size: 1em;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.0015em;
  color: rgba(0, 0, 0, 0.5);
  height: fit-content;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 0.5rem;
`

const Highglight = styled.span`
  color: var(--clr-secondary-dark);
`

const Header = ({ title, simple = false, remote = true }) => {
  return (
    <>
      <JobHeader>
        <JobInfo>
          <JobTitle>{title}</JobTitle>
          <JobLocation>
            Helsinki {remote && "or remote (FIN)"} <Highglight>//</Highglight>{" "}
            Full-time <br />
            Please note that we currently only consider applicants based in
            Finland
          </JobLocation>
        </JobInfo>
        {!simple && (
          <ButtonContainer>
            <ApplyButton to="apply#form">Apply now</ApplyButton>
            <ShareSection>
              <ShareText>Share on:</ShareText>
              <ShareLinks />
            </ShareSection>
          </ButtonContainer>
        )}
      </JobHeader>
    </>
  )
}

export default Header
